import styled from 'styled-components';

interface IContainerProps {
    backgroundColor?: string;
    activeBackgroundColor?: string;
    maxHeight?: string;
}

export const Container = styled.div<IContainerProps>`
    & .nav-item {
        background-color: ${props => props.backgroundColor || '#fff'};
        flex: 1;
        text-align: center;

        & .nav-link {
            color: #7c7f81;
        }

        & .active {
            background-color: ${props => props.activeBackgroundColor || '#74ace3'};
            color: ${props => props.activeBackgroundColor ? '#000' : '#fff'};
            font-weight: bold;
        }
    }

    & .nav-link {
        border-radius: 0px;
    }
`

export const ContainerTabContent = styled.div<IContainerProps>`
    border: 1px solid ${props => props.activeBackgroundColor || '#74ace3'};
    padding: 10px;
    max-height: ${props => props.maxHeight || 'auto'};
    overflow-y: auto;
`

export const TabItem = styled.div`
    border-top: 1px solid #74ace3;
    padding: 10px 0px;
`;